export default __webpack_public_path__ + "static/media/icon-zoom.5acd9444.svg";